export class selectOption {
    Value = '';
    Label = '';
  }

export class ProductFilter {
  ProductCode = '';
  Depth = '';
  Flange = '';
  Thickness = '';
  KSI = '';
  Coating = '';
  Category = '';
}

export class Product {
  productCode = '';
  category = '';
  categoryLineNo = 0;
  //parentCategoryName = '';
  parentCategoryDisplay = '';
  path = '';
  isSelected = false;
  studItem = '';
  isTrackItem = false;
}

export class Category {
  lineNo = 0;
  parentLineNo = 0;
  categoryName = '';
  categoryDisplay = '';
  isVisible = false;
  isEnabled = false;
  path = '';
  depth = 0;
  isOpen = false;  

  subCategories = Array<Category>();
  products = Array<Product>();
}

export class Project {

  projectId = 0;
  projectName = 'Unnamed';
  jobInfo = '';
  gc = '';
  contractor = '';
  architect = '';
  architectProjectNumber = '';
  distributor = '';
  projectAddress = '';
  updatedDate = '';
  products = Array<Product>();
  useCoverPage = true;
  customerNo = '';
  jobIDRSWSG = '';
  isQuote = false;
  quoteNumber = '';
  addTrack = false;
}

export class LoginRequest {
  userName = '';
  password: string;
  rememberMe: false;
  customerNo: string;
}

export class RegistrationRequest {
  emailAddress = '';
  firstName = '';
  lastName = '';
  navCustomerNo = '';
  password = '';
  confirmPassword = '';
}

export class User {
  userId =0;
  userName = '';
  emailAddress = '';
  firstName = '';
  lastName = '';
  navCustomerNo = '';
  resetPassword: false;
  isLoggedIn: false;
}

export enum ProjectView {
  Save = 1,
  Copy,
  SaveAndDownload,
  SaveAndEmail,
  SaveAndZip,

} 
